import { Nullable, Undefinedable } from "@/api/ApiClient";

export type SettlementPaymentFormData = Undefinedable<Nullable<{
    id: string | undefined,
    descripcion: string,
    monto: number,
    vuelto: number,
    formaPago: string,
    digitosTarjeta: string,
    numAprobacion: string,
    estado: string,
    exchangeRate: number,
    created: string,
    user: string,
    recibeId: string,
    recibe: any,
    currencyId: string,
    currency: any,
    bankAccountId: string,
    bankAccount: any,
    creditOperatorId: string,
    creditOperator: any,
    settlementId: string,
    settlement: any,
}>>;

export const SettlementPaymentRelatedAttributes: Array<keyof SettlementPaymentFormData> = ["recibe", "currency", "bankAccount", "recibe", "creditOperator", "settlement"];